<template>
	<div>
		<div
			class="modal left fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<button
							class="button button-transparent button-modal-back"
							@click="close"
						>
							<i class="sk-icon-times"></i>
						</button>
						<UserPicture :size="30" />
						<h1 class="welcome-message">
							{{ greeting }}
						</h1>
						<div
							class="welcome-message-subtitle"
							v-if="business && business.name"
						>
							{{ business.name }}
						</div>
						<ul class="user-menu" v-if="isLoggedIn">
							<li :class="{ active: isHomeActive }">
								<button @click="buildingHomeClicked">
									Home
								</button>
							</li>
							<li
								:class="{ active: isMenuActive }"
								v-if="showMenuLink"
							>
								<button @click="buildingMenuClicked">
									Menu
								</button>
							</li>
							<li :class="{ active: isEventsActive }">
								<button @click="buildingEventsClicked">
									Events
								</button>
							</li>
							<li :class="{ active: isAccountActive }">
								<router-link
									to="/user/account"
									@click.native="userAccountClicked"
								>
									Account
								</router-link>
							</li>
							<li :class="{ active: isOrdersActive }">
								<router-link
									to="/user/orders"
									@click.native="userOrdersClicked"
								>
									Orders
								</router-link>
							</li>
							<li :class="{ active: isRewardsActive }">
								<router-link
									to="/user/rewards"
									@click.native="userRewardsClicked"
								>
									Rewards
								</router-link>
							</li>
							<li>
								<button @click="helpClicked">Help</button>
							</li>
							<li>
								<button @click="logoutClicked">Log Out</button>
							</li>
						</ul>
						<ul class="user-menu" v-else>
							<li>
								<button @click="loginClicked">Log In</button>
							</li>
							<li>
								<button @click="helpClicked">Help</button>
							</li>
						</ul>
						<img class="logo" alt="getREEF Logo" :src="$logoSrc" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-dialog {
	margin: 0;
}

.modal-content {
	height: 100vh;
	max-width: 360px;
}

.modal-body {
	border-radius: 0;
	align-items: flex-start;
	justify-content: flex-start;
	padding-top: 50px;
	padding-left: 50px;
}

.button-modal-back {
	right: 20px;
	left: unset;
}

.button-modal-back i {
	color: var(--sk-grey3);
}

.modal >>> .user-profile-picture {
	margin-bottom: 13px;
}

.welcome-message {
	display: flex;
	font-size: 14px;
	color: var(--gR-base-90);
	font-weight: 600;
}

.welcome-message-subtitle {
	font-size: 10px;
	color: var(--sk-grey3);
}

.user-menu {
	padding: 0;
	margin: 0;
	margin-top: 30px;
}

.user-menu li {
	margin-bottom: 30px;
}

.user-menu li.active a,
.user-menu li.active button {
	font-weight: 600;
	color: var(--gR-base-90);
}

.user-menu li a,
.user-menu li button {
	font-weight: 400;
	color: var(--sk-grey3);
	font-size: 14px;
	cursor: pointer;
	padding: 0;
	background: var(--gR-white);
}

.logo {
	width: 131px;
	position: absolute;
	bottom: -131px;
	left: 50px;
	opacity: 0;
	transition: bottom 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.modal.show .logo {
	bottom: 30px;
	opacity: 1;
}
</style>

<script>
import api from "@/api"
import { EventBusEvents } from "@/enums/EventBusEvents"
import { MenuType } from "@reef-os/utils/enums/menuType"
import { eventBus } from "@/eventBus"
import UserPicture from "@/components/common/UserPicture.vue"

export default {
	name: "UserMenuModal",
	components: {
		UserPicture
	},
	data: function () {
		return {
			suppressHiddenEvent: false
		}
	},
	computed: {
		isLoggedIn() {
			return this.$store.state.user && this.$store.state.user.id != 0
		},
		isHomeActive() {
			return this.$route.name == "home"
		},
		isMenuActive() {
			return (
				this.$route.name == "menu" || this.$route.name == "menu_token"
			)
		},
		isEventsActive() {
			return this.$route.name == "events"
		},
		isAccountActive() {
			return this.$route.name == "account"
		},
		isOrdersActive() {
			return this.$route.name == "orders"
		},
		isRewardsActive() {
			return this.$route.name == "rewards"
		},
		showMenuLink() {
			if (
				this.business &&
				this.business.id &&
				this.business.menus.length > 0
			) {
				return (
					this.$store.state.business.menus.filter((menu) => {
						return (
							menu.type != MenuType.POPUP &&
							menu.type != MenuType.PRE_PACKAGED
						)
					}).length > 0
				)
			} else {
				return false
			}
		},

		business() {
			return this.$store.state.business
		},
		greeting() {
			if (this.isLoggedIn) {
				return this.$store.state.user.username
			}
			return "Welcome!"
		}
	},
	methods: {
		open() {
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		userAccountClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Account Clicked"
			})
			this.close()
		},
		userOrdersClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Orders Clicked"
			})
			this.close()
		},
		userRewardsClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Rewards Clicked"
			})
			this.close()
		},
		loginClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Login Clicked"
			})
			this.close()
			this.suppressHiddenEvent = true
			eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW)
		},
		logoutClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Logout Clicked"
			})
			this.close()
			this.suppressHiddenEvent = true
			this.goToResidentialHome()
			this.$store.dispatch("clearUserData")
		},
		helpClicked() {
			this.close()
			this.suppressHiddenEvent = true
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Support Clicked"
			})
			eventBus.emit(EventBusEvents.OPEN_SUPPORT_MODAL)
		},
		async goToResidentialHome() {
			const business = this.$store.state.business
			if (
				business &&
				business.id == this.$store.state.user.businessId &&
				business.slug
			) {
				this.$router.push({ path: `/${business.slug}` })
			} else {
				const slug = await this.getBusinessSlug()
				if (slug) {
					window.location.href = `${window.location.origin}/${slug}`
				}
			}
		},
		async buildingHomeClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Home Clicked"
			})
			this.goToResidentialHome()
			this.close()
		},
		async buildingMenuClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Building Menu Clicked"
			})
			const business = this.$store.state.business
			if (business && business.slug) {
				this.$router.push({ path: `/${business.slug}/menu` })
			} else {
				const slug = await this.getBusinessSlug()
				if (slug) {
					window.location.href = `${window.location.origin}/${slug}/menu`
				}
			}
			this.close()
		},
		async buildingEventsClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "User Menu Building Events Clicked"
			})
			const business = this.$store.state.business
			if (business && business.slug) {
				this.$router.push({ path: `/${business.slug}/events` })
			} else {
				const slug = await this.getBusinessSlug()
				if (slug) {
					window.location.href = `${window.location.origin}/${slug}/events`
				}
			}
			this.close()
		},
		async getBusinessSlug() {
			const response = await api.getBusiness(
				this.$store.state.user.businessId
			)
			if (response && response.data && response.data.slug) {
				return response.data.slug
			} else {
				return null
			}
		}
	},
	mounted: function () {
		$(this.$refs.modal).on("show.bs.modal", () => {
			this.$emit("show")
		})

		$(this.$refs.modal).on("hidden.bs.modal", () => {
			if (this.suppressHiddenEvent) {
				this.suppressHiddenEvent = false
				return
			}
			this.$emit("hidden")
		})
	}
}
</script>
